module.exports = __webpack_public_path__ + "static/media/texture-teal.86d8c5eb.png";